import { createReducer } from "redux-act";
import { closeBollinger } from "../actions";

let isBollingerLocal = localStorage.getItem("bollconfig");

if (!isBollingerLocal) {
  localStorage.setItem("bollconfig", false);
} else {
  isBollingerLocal = JSON.parse(isBollingerLocal);
}

const initialState = {
  isBollingerClosed: isBollingerLocal || false, // Giá trị mặc định
};
export default createReducer(
  {
    [closeBollinger]: (state, payload) => {
      localStorage.setItem("bollconfig", !state.isBollingerClosed);
      return { ...state, isBollingerClosed: !state.isBollingerClosed };
    },
  },
  initialState
);
